<app-aumico-layout [hideFooter]="true">
    <ng-container header>
        <ham-page-header [title]="'aumico_projects_overview_page_header' | i18next" [hasBackButton]="false"></ham-page-header>
        <div class="tabs-row">
            <div class="tabs-container">
                <div class="tab" [class.active]="!displayAllProjects" (click)="onDisplayMyProjects()">
                    <span>{{ 'aumico_reports_my_projects' | i18next }}</span>
                </div>
                <div class="tab" [class.active]="displayAllProjects" (click)="onDisplayAllProjects()">
                    <span>{{ 'aumico_reports_all_projects' | i18next }}</span>
                </div>
            </div>
            <ham-segmented-toggle
                data-testid="projects-subject-toggle"
                optionTestIdPrefix="subject-toggle"
                [options]="subjectToggleOptions"
                [selected]="toggleValue"
                (selectionChange)="onSubjectToggle($event)"
            ></ham-segmented-toggle>
        </div>
        <div class="filters-container">
            <div class="search-wrapper">
                <ham-filter
                    [value]="filter.personName || ''"
                    [placeholder]="'aumico_projects_overview_search_projects' | i18next"
                    [hasFilterButton]="false"
                    (filter)="onSearchFilterChange($event)"
                ></ham-filter>
            </div>
            <div class="button-filters-wrapper">
                <user-filter-drop-down
                    [label]="'aumico_person_projects_filter_person' | i18next"
                    [users]="personOptions"
                    [selectedUserIds]="filter.personIds || []"
                    [showAvatar]="false"
                    view="projects"
                    data-testid="person-projects-filter-person"
                    (userChange)="onPersonFilterChange($event)"
                ></user-filter-drop-down>
                <due-date-filter-drop-down
                    translationKeyFilterName="aumico_person_projects_filter_period"
                    [selectedYears]="filter.years || []"
                    (filterChange)="onYearFilterChange($event)"
                ></due-date-filter-drop-down>
                <user-filter-drop-down
                    *ngIf="displayAllProjects"
                    label="aumico_projects_overview_filter_assignee_label"
                    view="projects"
                    [users]="assigneeOptions"
                    [currentUserId]="activeUserAumicoInternalId"
                    [selectedUserIds]="filter.assignee || []"
                    (userChange)="onAssigneeFilterChange($event)"
                ></user-filter-drop-down>
                <status-filter-drop-down
                    [statusOptions]="statusOptions"
                    [selectedStatus]="filter.projectStatus || []"
                    (statusChange)="onStatusFilterChange($event)"
                ></status-filter-drop-down>
                <user-filter-drop-down
                    *ngIf="showTags"
                    [label]="'aumico_person_projects_filter_tag' | i18next"
                    [users]="tagOptions"
                    [selectedUserIds]="filter.tagIds || []"
                    [showAvatar]="false"
                    view="projects"
                    data-testid="person-projects-filter-tag"
                    (userChange)="onTagFilterChange($event)"
                ></user-filter-drop-down>
                <ham-button
                    class="create-project-button"
                    variant="primary"
                    icon="assets/hamIcons/plus-outline.svg"
                    size="lg"
                    data-testid="person-projects-new"
                    (buttonClick)="openCreateProjectDialog()"
                    >{{ 'aumico_projects_overview_add_new_project' | i18next }}</ham-button
                >
            </div>
        </div>
    </ng-container>
    <ng-container content>
        <div class="projects-overview-container">
            <aumico-person-project-overview-table
                [projects]="tableData"
                [activeNav]="activeNav"
                [showTags]="showTags"
                [anyActiveFilter]="isAnyFilterActive()"
                [activeSortBy]="filter.sortBy || null"
                [activeSortOrder]="activeSortOrder"
                [allProjectsSelected]="allProjectsSelected"
                [selectedProjects]="selectedProjects"
                (sortProjects)="sortProjects($event)"
                (updateProjectStatus)="onUpdateProjectStatus($event)"
                (deleteProject)="onDeleteProject($event)"
                (selectProject)="onSelectProject($event)"
                (changeTaskState)="onChangeTaskState($event)"
                (toggleCheckAllProject)="onToggleCheckAllProject()"
                (toggleCheckProject)="onToggleCheckProject($event)"
                (addNewProject)="openCreateProjectDialog()"
            ></aumico-person-project-overview-table>
        </div>
    </ng-container>
</app-aumico-layout>

<ham-modal *ngIf="showCreateProjectPopup" class="feedback" [hideFooter]="true" [showCancelButton]="'false'" hideHeader="true">
    <new-person-project-wizard
        [personsList]="activePersons"
        [lastProjectYearByPersonId]="lastProjectYearByPersonId"
        (create)="onCreateProject($event)"
        (closeButtonClicked)="showCreateProjectPopup = false"
    ></new-person-project-wizard>
</ham-modal>

<bulk-edit-action-bar
    *ngIf="selectedProjects.size > 0"
    [selectedCount]="selectedProjects.size"
    [actions]="bulkActions"
    [deleteAction]="deleteAction"
    textSelectedTranslationKey="aumico_companies_bulk_edit_action_bar_selected_text"
    [globalPosition]="true"
    (actionClicked)="onActionClicked($event)"
></bulk-edit-action-bar>

<ham-modal
    *ngIf="openBulkEditStatus"
    [title]="'aumico_project_overview_bulk_update_status' | i18next : { count: selectedProjects.size }"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    [saveText]="'aumico_button_save' | i18next"
    (cancel)="openBulkEditStatus = false"
    (save)="editStatusSelected()"
    ><input
        hamSimpleDropDown
        [label]="'aumico_project_overview_bulk_update_status_label' | i18next"
        [options]="possibleStatus"
        [optionKeys]="['name']"
        returnKey="id"
        [returnObject]="true"
        [placeholder]="'aumico_project_overview_bulk_update_status_placeholder' | i18next"
        [formControl]="bulkEditStatusControl"
/></ham-modal>

<ham-confirm-decline-modal
    *ngIf="openAutoTaskUpdateDialog"
    (cancel)="onEditStatusConfirm(false)"
    (action)="onEditStatusConfirm(true)"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_projects_overview_status_update_modal_confirm' | i18next }}"
    noActionBtnText="{{ 'aumico_projects_overview_status_update_modal_cancel' | i18next }}"
    btnVariant="primary"
>
    <div class="ham-icon"><i class="check-circle-outline"></i></div>
    <p class="project-update-modal-text">{{ 'aumico_projects_overview_status_update_modal_text' | i18next }}</p>
</ham-confirm-decline-modal>

<ham-confirm-decline-modal
    *ngIf="openBulkDeleteConfirmationDialog"
    (cancel)="openBulkDeleteConfirmationDialog = false"
    (action)="confirmDeleteBulkProjects()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_button_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_button_cancel' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_app_cpmm_projects_delete_confirmation' | i18next : { count: selectedProjects.size }"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
